import React from 'react';
import { css } from 'linaria';
import { Autoplay } from 'swiper/modules';
import { createElementKey } from 'utils';
import { Swiper, SwiperSlide } from '../../swiper';
import { PictureContent, PictureContentProps } from '../picture-content';

const swiperStyle = css`
  && {
    position: absolute;
    top: 0;
    left: 520px;
    width: 768px;
    height: 480px;

    @media (--only-desktop) {
      left: calc(486px + var(--fronton-layout-gutter));
      width: 496px;
    }

    @media (--to-desktop) {
      position: relative;
      left: 0;
      width: 100vw;
      height: 100%;
      padding: 0;
      margin: 0;
    }
  }
`;

const carouselImage = css`
  && {
    position: unset;
    display: block;
    width: 100%;
    height: 100%;
  }
`;

type CarouselContentProps = {
  carouselList: PictureContentProps[];
};

export const CarouselContent: React.FC<CarouselContentProps> = ({ carouselList }) => (
  <Swiper
    className={swiperStyle}
    slidesPerView="auto"
    watchOverflow
    autoplay
    loop
    noSwiping
    noSwipingClass={swiperStyle}
    modules={[Autoplay]}>
    {carouselList.map((carouselItem: PictureContentProps, index: number) => (
      <SwiperSlide key={createElementKey('slide', index)}>
        <PictureContent className={carouselImage} {...carouselItem} />
      </SwiperSlide>
    ))}
  </Swiper>
);
